import makeExceptionLogger from '~/libs/exception-logger';

export default makeExceptionLogger;
